module.exports = __webpack_public_path__ + "img/fiat-smartrace-autoshow-01.e9d93b57.jpg";